import * as ActionTypes from '../constants/ActionTypes';
const crf = JSON.parse(localStorage.getItem('crf'));
const initialState = {
	crf_id: crf && crf.crf_id ? crf.crf_id : ''
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.UPDATE_DRAWER_FIELD:
			return {
				...state,
				...(action.payload.fieldName && action.payload.fieldValue && { [action.payload.fieldName]: action.payload.fieldValue }),
				...action.payload
			};
		default:
			return state;
	}
}
